import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GutachtenService } from '../../../api/services/gutachten.service';
import { GutachtenListDisplayModel } from '@/api/model-index';

@Injectable({
  providedIn: 'root'
})
export class PersonalReviewListResolver implements Resolve<GutachtenListDisplayModel[]> {
  constructor(protected gutachtenService: GutachtenService)
  {
    //
  }

  /**
   * Get all applications containing projects and projectideas.
   * 
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   * @returns Observable<BewerbungListDisplayModel>
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GutachtenListDisplayModel[]> {
    return this.gutachtenService.apiGutachtenGetPersonalReviewListGet().pipe(map(response => {
      return response;
    }));
  }
}
